import React from "react"
import { Redirect } from "react-router-dom"

import { SsoMode } from "@cirrus/common/CustomerInfo/types"

import { LoginWithPasswordScreenContent } from "./ScreenContent"
import { useCustomerInfo } from "../../../CustomerInfo"

export const LoginWithPasswordProtectedScreenContent = () => {
  const { data } = useCustomerInfo()
  const allowed = data?.saml?.ssoMode !== SsoMode.Enforced
  return allowed ? <LoginWithPasswordScreenContent/> : <Redirect to="/"/>
}
